import { Directive, HostListener, Input } from '@angular/core';
import { BackNavigationService } from '@modules/core/services/back-navigation.service';

@Directive({
  selector: '[appGoBack]'
})
export class GoBackDirective {
  @Input() latitude: string | number;
  @Input() longitude: string | number;
  @Input() paramId: string;
  constructor(private backNavigationService: BackNavigationService) { }

  @HostListener('click',['$event.target']) 
  goBack() {
    this.backNavigationService.goBack({
      lon: this.longitude,
      lat: this.latitude,
      id: this.paramId,
    });
  }

}
